import React from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";

import RedirectComponent from "../../../../atoms/RedirectComponent/RedirectComponent";

const IncentiveSpirometerPage: React.FC<any> = () => {
  return (
    <div>
      <PageHeader title="Incentive Spirometer" />
      <RedirectComponent moduleName="spirometer" />
    </div>
  );
};

export default IncentiveSpirometerPage;
